import React from 'react'
import PropTypes from 'prop-types'
import { ItemContentHandler } from 'shared/Components/ItemContent/ItemContentHandler'
import { ITEM_CONTENT_ACTIONS } from 'shared/constants'
import {
  getFileMetadata, analyzeUrl, createSnapshotUrl
} from 'LiveBoard/api/contentItems'

const ItemContentHandlerRenderer = (props) => {
  const itemContentActionHandler = {
    [ITEM_CONTENT_ACTIONS.createSnapshotUrl]: createSnapshotUrl,
    [ITEM_CONTENT_ACTIONS.analyzeUrl]: analyzeUrl,
    [ITEM_CONTENT_ACTIONS.getFileMetadata]: getFileMetadata
  }

  return (
    <ItemContentHandler itemContentActionHandler={itemContentActionHandler}>
      { props.children }
    </ItemContentHandler>
  )
}

export default ItemContentHandlerRenderer